/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.11
 */
import * as reactQuery from "@tanstack/react-query";
import { useV3ApiContext, V3ApiContext } from "./v3ApiContext";
import type * as Fetcher from "./v3ApiFetcher";
import { v3ApiFetch } from "./v3ApiFetcher";
import type * as Schemas from "./v3ApiSchemas";

export type PostClusterPathParams = {
  orgId: string;
};

export type PostClusterError = Fetcher.ErrorWrapper<undefined>;

export type PostClusterVariables = {
  body: Schemas.ClusterUpdate;
  pathParams: PostClusterPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchPostCluster = (
  variables: PostClusterVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ClusterCreationRevisionResponse,
    PostClusterError,
    Schemas.ClusterUpdate,
    {},
    {},
    PostClusterPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters",
    method: "post",
    ...variables,
    signal,
  });

export const usePostCluster = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ClusterCreationRevisionResponse,
      PostClusterError,
      PostClusterVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.ClusterCreationRevisionResponse,
    PostClusterError,
    PostClusterVariables
  >({
    mutationFn: (variables: PostClusterVariables) =>
      fetchPostCluster({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PatchOrganisationFeaturesPathParams = {
  /**
   * Organisation ID
   */
  orgId: string;
};

export type PatchOrganisationFeaturesError = Fetcher.ErrorWrapper<undefined>;

export type PatchOrganisationFeaturesVariables = {
  body?: Schemas.OrganisationFeatures;
  pathParams: PatchOrganisationFeaturesPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchPatchOrganisationFeatures = (
  variables: PatchOrganisationFeaturesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.OrganisationFeatures,
    PatchOrganisationFeaturesError,
    Schemas.OrganisationFeatures,
    {},
    {},
    PatchOrganisationFeaturesPathParams
  >({
    url: "/api/v3/orgs/{orgId}/features",
    method: "patch",
    ...variables,
    signal,
  });

export const usePatchOrganisationFeatures = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.OrganisationFeatures,
      PatchOrganisationFeaturesError,
      PatchOrganisationFeaturesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.OrganisationFeatures,
    PatchOrganisationFeaturesError,
    PatchOrganisationFeaturesVariables
  >({
    mutationFn: (variables: PatchOrganisationFeaturesVariables) =>
      fetchPatchOrganisationFeatures({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetOrganisationFeaturesPathParams = {
  /**
   * Organisation ID
   */
  orgId: string;
};

export type GetOrganisationFeaturesError = Fetcher.ErrorWrapper<undefined>;

export type GetOrganisationFeaturesVariables = {
  pathParams: GetOrganisationFeaturesPathParams;
} & V3ApiContext["fetcherOptions"];

/**
 * Retrieve all features for the organization
 */
export const fetchGetOrganisationFeatures = (
  variables: GetOrganisationFeaturesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.OrganisationFeatures,
    GetOrganisationFeaturesError,
    undefined,
    {},
    {},
    GetOrganisationFeaturesPathParams
  >({
    url: "/api/v3/orgs/{orgId}/features",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Retrieve all features for the organization
 */
export const useGetOrganisationFeatures = <
  TData = Schemas.OrganisationFeatures,
>(
  variables: GetOrganisationFeaturesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.OrganisationFeatures,
      GetOrganisationFeaturesError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    Schemas.OrganisationFeatures,
    GetOrganisationFeaturesError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/orgs/{orgId}/features",
      operationId: "getOrganisationFeatures",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetOrganisationFeatures({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetOrgUsersPathParams = {
  /**
   * Organisation ID
   */
  orgId: string;
};

export type GetOrgUsersError = Fetcher.ErrorWrapper<undefined>;

export type GetOrgUsersResponse = Schemas.OrgUser[];

export type GetOrgUsersVariables = {
  pathParams: GetOrgUsersPathParams;
} & V3ApiContext["fetcherOptions"];

/**
 * Retrieve all users in an organisation with their RBAC roles
 */
export const fetchGetOrgUsers = (
  variables: GetOrgUsersVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    GetOrgUsersResponse,
    GetOrgUsersError,
    undefined,
    {},
    {},
    GetOrgUsersPathParams
  >({ url: "/api/v3/orgs/{orgId}/users", method: "get", ...variables, signal });

/**
 * Retrieve all users in an organisation with their RBAC roles
 */
export const useGetOrgUsers = <TData = GetOrgUsersResponse,>(
  variables: GetOrgUsersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetOrgUsersResponse, GetOrgUsersError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<GetOrgUsersResponse, GetOrgUsersError, TData>({
    queryKey: queryKeyFn({
      path: "/api/v3/orgs/{orgId}/users",
      operationId: "getOrgUsers",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetOrgUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ListSupportUsersPathParams = {
  /**
   * Organisation ID
   */
  orgId: string;
};

export type ListSupportUsersError = Fetcher.ErrorWrapper<undefined>;

export type ListSupportUsersVariables = {
  pathParams: ListSupportUsersPathParams;
} & V3ApiContext["fetcherOptions"];

/**
 * Retrieve all HiveMQ support users currently assigned to this organisation
 */
export const fetchListSupportUsers = (
  variables: ListSupportUsersVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.SupportUserList,
    ListSupportUsersError,
    undefined,
    {},
    {},
    ListSupportUsersPathParams
  >({
    url: "/api/v3/orgs/{orgId}/support-users",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Retrieve all HiveMQ support users currently assigned to this organisation
 */
export const useListSupportUsers = <TData = Schemas.SupportUserList,>(
  variables: ListSupportUsersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SupportUserList,
      ListSupportUsersError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    Schemas.SupportUserList,
    ListSupportUsersError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/orgs/{orgId}/support-users",
      operationId: "listSupportUsers",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListSupportUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type AddSupportUserPathParams = {
  /**
   * Organisation ID
   */
  orgId: string;
};

export type AddSupportUserError = Fetcher.ErrorWrapper<undefined>;

export type AddSupportUserVariables = {
  body: Schemas.AddSupportUserRequest;
  pathParams: AddSupportUserPathParams;
} & V3ApiContext["fetcherOptions"];

/**
 * Assign a HiveMQ support user to a customer organisation with the support_admin role
 */
export const fetchAddSupportUser = (
  variables: AddSupportUserVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.SupportUser,
    AddSupportUserError,
    Schemas.AddSupportUserRequest,
    {},
    {},
    AddSupportUserPathParams
  >({
    url: "/api/v3/orgs/{orgId}/support-users",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Assign a HiveMQ support user to a customer organisation with the support_admin role
 */
export const useAddSupportUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SupportUser,
      AddSupportUserError,
      AddSupportUserVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.SupportUser,
    AddSupportUserError,
    AddSupportUserVariables
  >({
    mutationFn: (variables: AddSupportUserVariables) =>
      fetchAddSupportUser({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RemoveSupportUserPathParams = {
  /**
   * Organisation ID
   */
  orgId: string;
  /**
   * Support user ID to remove
   */
  userId: string;
};

export type RemoveSupportUserError = Fetcher.ErrorWrapper<undefined>;

export type RemoveSupportUserVariables = {
  pathParams: RemoveSupportUserPathParams;
} & V3ApiContext["fetcherOptions"];

/**
 * Remove a HiveMQ support user from a customer organisation
 */
export const fetchRemoveSupportUser = (
  variables: RemoveSupportUserVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    RemoveSupportUserError,
    undefined,
    {},
    {},
    RemoveSupportUserPathParams
  >({
    url: "/api/v3/orgs/{orgId}/support-users/{userId}",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Remove a HiveMQ support user from a customer organisation
 */
export const useRemoveSupportUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RemoveSupportUserError,
      RemoveSupportUserVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    undefined,
    RemoveSupportUserError,
    RemoveSupportUserVariables
  >({
    mutationFn: (variables: RemoveSupportUserVariables) =>
      fetchRemoveSupportUser({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetOrganizationClusterTagsPathParams = {
  /**
   * Organisation ID
   */
  orgId: string;
};

export type GetOrganizationClusterTagsError = Fetcher.ErrorWrapper<undefined>;

export type GetOrganizationClusterTagsResponse = string[];

export type GetOrganizationClusterTagsVariables = {
  pathParams: GetOrganizationClusterTagsPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetOrganizationClusterTags = (
  variables: GetOrganizationClusterTagsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    GetOrganizationClusterTagsResponse,
    GetOrganizationClusterTagsError,
    undefined,
    {},
    {},
    GetOrganizationClusterTagsPathParams
  >({ url: "/api/v3/orgs/{orgId}/tags", method: "get", ...variables, signal });

export const useGetOrganizationClusterTags = <
  TData = GetOrganizationClusterTagsResponse,
>(
  variables: GetOrganizationClusterTagsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetOrganizationClusterTagsResponse,
      GetOrganizationClusterTagsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    GetOrganizationClusterTagsResponse,
    GetOrganizationClusterTagsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/orgs/{orgId}/tags",
      operationId: "getOrganizationClusterTags",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetOrganizationClusterTags(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type GetOrganisationIdpConnectionsPathParams = {
  /**
   * Organisation ID
   */
  orgId: string;
};

export type GetOrganisationIdpConnectionsError =
  Fetcher.ErrorWrapper<undefined>;

export type GetOrganisationIdpConnectionsVariables = {
  pathParams: GetOrganisationIdpConnectionsPathParams;
} & V3ApiContext["fetcherOptions"];

/**
 * Retrieve all identity provider connections for the organization
 */
export const fetchGetOrganisationIdpConnections = (
  variables: GetOrganisationIdpConnectionsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.IdpConnectionsResponse,
    GetOrganisationIdpConnectionsError,
    undefined,
    {},
    {},
    GetOrganisationIdpConnectionsPathParams
  >({
    url: "/api/v3/orgs/{orgId}/idpConnections",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Retrieve all identity provider connections for the organization
 */
export const useGetOrganisationIdpConnections = <
  TData = Schemas.IdpConnectionsResponse,
>(
  variables: GetOrganisationIdpConnectionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.IdpConnectionsResponse,
      GetOrganisationIdpConnectionsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    Schemas.IdpConnectionsResponse,
    GetOrganisationIdpConnectionsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/orgs/{orgId}/idpConnections",
      operationId: "getOrganisationIdpConnections",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetOrganisationIdpConnections(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type UpdateOrganisationIdpConnectionPathParams = {
  /**
   * HiveMQ Organization ID
   */
  orgId: string;
  /**
   * Auth0 SSO connection ID to update
   */
  connectionId: string;
};

export type UpdateOrganisationIdpConnectionError =
  Fetcher.ErrorWrapper<undefined>;

export type UpdateOrganisationIdpConnectionRequestBody = {
  /**
   * Indicates whether the IDP connection should be enabled or disabled.
   */
  enabled?: boolean;
};

export type UpdateOrganisationIdpConnectionVariables = {
  body?: UpdateOrganisationIdpConnectionRequestBody;
  pathParams: UpdateOrganisationIdpConnectionPathParams;
} & V3ApiContext["fetcherOptions"];

/**
 * Updates (Enable/Disable) an existing identity provider connection for the organization. The authenticated user must be an owner or admin of the organization.
 */
export const fetchUpdateOrganisationIdpConnection = (
  variables: UpdateOrganisationIdpConnectionVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.IdpConnection,
    UpdateOrganisationIdpConnectionError,
    UpdateOrganisationIdpConnectionRequestBody,
    {},
    {},
    UpdateOrganisationIdpConnectionPathParams
  >({
    url: "/api/v3/orgs/{orgId}/idpConnections/{connectionId}",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Updates (Enable/Disable) an existing identity provider connection for the organization. The authenticated user must be an owner or admin of the organization.
 */
export const useUpdateOrganisationIdpConnection = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.IdpConnection,
      UpdateOrganisationIdpConnectionError,
      UpdateOrganisationIdpConnectionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.IdpConnection,
    UpdateOrganisationIdpConnectionError,
    UpdateOrganisationIdpConnectionVariables
  >({
    mutationFn: (variables: UpdateOrganisationIdpConnectionVariables) =>
      fetchUpdateOrganisationIdpConnection({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetClusterPathParams = {
  orgId: string;
  clusterId: string;
};

export type GetClusterError = Fetcher.ErrorWrapper<undefined>;

export type GetClusterVariables = {
  pathParams: GetClusterPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetCluster = (
  variables: GetClusterVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ClusterHead,
    GetClusterError,
    undefined,
    {},
    {},
    GetClusterPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}",
    method: "get",
    ...variables,
    signal,
  });

export const useGetCluster = <TData = Schemas.ClusterHead,>(
  variables: GetClusterVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ClusterHead, GetClusterError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<Schemas.ClusterHead, GetClusterError, TData>({
    queryKey: queryKeyFn({
      path: "/api/v3/orgs/{orgId}/clusters/{clusterId}",
      operationId: "getCluster",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetCluster({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type DeleteClusterPathParams = {
  /**
   * Organisation ID
   */
  orgId: string;
  /**
   * Cluster id to delete
   */
  clusterId: string;
};

export type DeleteClusterError = Fetcher.ErrorWrapper<undefined>;

export type DeleteClusterVariables = {
  pathParams: DeleteClusterPathParams;
} & V3ApiContext["fetcherOptions"];

/**
 * delete a Cluster
 */
export const fetchDeleteCluster = (
  variables: DeleteClusterVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    DeleteClusterError,
    undefined,
    {},
    {},
    DeleteClusterPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * delete a Cluster
 */
export const useDeleteCluster = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteClusterError,
      DeleteClusterVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteClusterError,
    DeleteClusterVariables
  >({
    mutationFn: (variables: DeleteClusterVariables) =>
      fetchDeleteCluster({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PutClusterPathParams = {
  orgId: string;
  clusterId: string;
};

export type PutClusterError = Fetcher.ErrorWrapper<undefined>;

export type PutClusterVariables = {
  body: Schemas.ClusterUpdate;
  pathParams: PutClusterPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchPutCluster = (
  variables: PutClusterVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.RevisionResponse,
    PutClusterError,
    Schemas.ClusterUpdate,
    {},
    {},
    PutClusterPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}",
    method: "put",
    ...variables,
    signal,
  });

export const usePutCluster = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RevisionResponse,
      PutClusterError,
      PutClusterVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.RevisionResponse,
    PutClusterError,
    PutClusterVariables
  >({
    mutationFn: (variables: PutClusterVariables) =>
      fetchPutCluster({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetBulkClusterUpdatesDetailsQueryParams = {
  /**
   * Workflow status (e.g., RUNNING, COMPLETED, FAILED, etc.)
   */
  status?: string;
  /**
   * Filter by start date (epoch milliseconds)
   *
   * @format int64
   */
  startDate?: number;
  /**
   * Filter by end date (epoch milliseconds)
   *
   * @format int64
   */
  endDate?: number;
  /**
   * Temporal namespace to filter by
   */
  namespace?: string;
  /**
   * @default 50
   */
  pageSize?: number;
  /**
   * Token to fetch the next page of results
   */
  nextPageToken?: string;
  /**
   * Filter by workflow type name (e.g, BulkUpdateWorkflow)
   *
   * @default BulkUpdateWorkflow
   */
  type?: string;
  /**
   * Filter by workflow ID
   */
  workflowId?: string;
};

export type GetBulkClusterUpdatesDetailsError = Fetcher.ErrorWrapper<undefined>;

export type GetBulkClusterUpdatesDetailsResponse = {
  workflows?: {
    workflowId?: string;
    runId?: string;
    type?: string;
    status?: string;
    /**
     * Start time in epoch milliseconds
     *
     * @format int64
     */
    startTime?: number;
    /**
     * Execution time in epoch milliseconds
     *
     * @format int64
     */
    executionTime?: number;
    namespace?: string;
  }[];
  /**
   * Token for fetching the next page of results
   */
  nextPageToken?: string;
};

export type GetBulkClusterUpdatesDetailsVariables = {
  queryParams?: GetBulkClusterUpdatesDetailsQueryParams;
} & V3ApiContext["fetcherOptions"];

/**
 * Retrieve a list of all update / bulk cluster details
 */
export const fetchGetBulkClusterUpdatesDetails = (
  variables: GetBulkClusterUpdatesDetailsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    GetBulkClusterUpdatesDetailsResponse,
    GetBulkClusterUpdatesDetailsError,
    undefined,
    {},
    GetBulkClusterUpdatesDetailsQueryParams,
    {}
  >({
    url: "/api/v3/clusters/bulk-update/details",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Retrieve a list of all update / bulk cluster details
 */
export const useGetBulkClusterUpdatesDetails = <
  TData = GetBulkClusterUpdatesDetailsResponse,
>(
  variables: GetBulkClusterUpdatesDetailsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetBulkClusterUpdatesDetailsResponse,
      GetBulkClusterUpdatesDetailsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    GetBulkClusterUpdatesDetailsResponse,
    GetBulkClusterUpdatesDetailsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/clusters/bulk-update/details",
      operationId: "getBulkClusterUpdatesDetails",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetBulkClusterUpdatesDetails(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type GetBulkClusterUpdatesQueryParams = {
  /**
   * The page number for pagination.
   *
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @example asc
   * @default desc
   */
  order?: "asc" | "desc";
};

export type GetBulkClusterUpdatesError = Fetcher.ErrorWrapper<undefined>;

export type GetBulkClusterUpdatesVariables = {
  queryParams?: GetBulkClusterUpdatesQueryParams;
} & V3ApiContext["fetcherOptions"];

/**
 * Retrieve a list of all bulk cluster update requests with their current status
 */
export const fetchGetBulkClusterUpdates = (
  variables: GetBulkClusterUpdatesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.BulkUpdatesResponse,
    GetBulkClusterUpdatesError,
    undefined,
    {},
    GetBulkClusterUpdatesQueryParams,
    {}
  >({
    url: "/api/v3/clusters/bulk-update",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Retrieve a list of all bulk cluster update requests with their current status
 */
export const useGetBulkClusterUpdates = <TData = Schemas.BulkUpdatesResponse,>(
  variables: GetBulkClusterUpdatesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BulkUpdatesResponse,
      GetBulkClusterUpdatesError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    Schemas.BulkUpdatesResponse,
    GetBulkClusterUpdatesError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/clusters/bulk-update",
      operationId: "getBulkClusterUpdates",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetBulkClusterUpdates({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type SubmitBulkClusterUpdateError = Fetcher.ErrorWrapper<undefined>;

export type SubmitBulkClusterUpdateResponse = {
  /**
   * Unique identifier for the bulk update operation
   */
  bulkUpdateId: string;
};

export type SubmitBulkClusterUpdateVariables = {
  body: Schemas.BulkClusterUpdate;
} & V3ApiContext["fetcherOptions"];

/**
 * Submit multiple clusters for asynchronous update to a specified template. The clusters will be processed later and individual revisions will be created that require approval through the standard workflow.
 */
export const fetchSubmitBulkClusterUpdate = (
  variables: SubmitBulkClusterUpdateVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    SubmitBulkClusterUpdateResponse,
    SubmitBulkClusterUpdateError,
    Schemas.BulkClusterUpdate,
    {},
    {},
    {}
  >({
    url: "/api/v3/clusters/bulk-update",
    method: "put",
    ...variables,
    signal,
  });

/**
 * Submit multiple clusters for asynchronous update to a specified template. The clusters will be processed later and individual revisions will be created that require approval through the standard workflow.
 */
export const useSubmitBulkClusterUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      SubmitBulkClusterUpdateResponse,
      SubmitBulkClusterUpdateError,
      SubmitBulkClusterUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    SubmitBulkClusterUpdateResponse,
    SubmitBulkClusterUpdateError,
    SubmitBulkClusterUpdateVariables
  >({
    mutationFn: (variables: SubmitBulkClusterUpdateVariables) =>
      fetchSubmitBulkClusterUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetBulkClusterUpdateDetailsPathParams = {
  /**
   * Unique identifier of the bulk update task (Temporal Workflow ID).
   *
   * @format uuid
   * @example bulk-update-123e4567-e89b-12d3-a456-426614174000
   */
  bulkUpdateId: string;
};

export type GetBulkClusterUpdateDetailsError = Fetcher.ErrorWrapper<undefined>;

export type GetBulkClusterUpdateDetailsVariables = {
  pathParams: GetBulkClusterUpdateDetailsPathParams;
} & V3ApiContext["fetcherOptions"];

/**
 * Retrieve comprehensive details about a single bulk cluster update request, including the status of each individual cluster affected.
 */
export const fetchGetBulkClusterUpdateDetails = (
  variables: GetBulkClusterUpdateDetailsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.BulkUpdateTaskDetails,
    GetBulkClusterUpdateDetailsError,
    undefined,
    {},
    {},
    GetBulkClusterUpdateDetailsPathParams
  >({
    url: "/api/v3/clusters/bulk-update/{bulkUpdateId}",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Retrieve comprehensive details about a single bulk cluster update request, including the status of each individual cluster affected.
 */
export const useGetBulkClusterUpdateDetails = <
  TData = Schemas.BulkUpdateTaskDetails,
>(
  variables: GetBulkClusterUpdateDetailsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BulkUpdateTaskDetails,
      GetBulkClusterUpdateDetailsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    Schemas.BulkUpdateTaskDetails,
    GetBulkClusterUpdateDetailsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/clusters/bulk-update/{bulkUpdateId}",
      operationId: "getBulkClusterUpdateDetails",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetBulkClusterUpdateDetails(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApproveBulkUpdatePathParams = {
  bulkUpdateId: string;
};

export type ApproveBulkUpdateError = Fetcher.ErrorWrapper<undefined>;

export type ApproveBulkUpdateVariables = {
  body: Schemas.ApprovalRequest;
  pathParams: ApproveBulkUpdatePathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchApproveBulkUpdate = (
  variables: ApproveBulkUpdateVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    ApproveBulkUpdateError,
    Schemas.ApprovalRequest,
    {},
    {},
    ApproveBulkUpdatePathParams
  >({
    url: "/api/v3/clusters/bulk-update/{bulkUpdateId}/approve",
    method: "put",
    ...variables,
    signal,
  });

export const useApproveBulkUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      ApproveBulkUpdateError,
      ApproveBulkUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    ApproveBulkUpdateError,
    ApproveBulkUpdateVariables
  >({
    mutationFn: (variables: ApproveBulkUpdateVariables) =>
      fetchApproveBulkUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RejectBulkUpdatePathParams = {
  bulkUpdateId: string;
};

export type RejectBulkUpdateError = Fetcher.ErrorWrapper<undefined>;

export type RejectBulkUpdateVariables = {
  body: Schemas.ApprovalRequest;
  pathParams: RejectBulkUpdatePathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchRejectBulkUpdate = (
  variables: RejectBulkUpdateVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    RejectBulkUpdateError,
    Schemas.ApprovalRequest,
    {},
    {},
    RejectBulkUpdatePathParams
  >({
    url: "/api/v3/clusters/bulk-update/{bulkUpdateId}/reject",
    method: "put",
    ...variables,
    signal,
  });

export const useRejectBulkUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      RejectBulkUpdateError,
      RejectBulkUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    RejectBulkUpdateError,
    RejectBulkUpdateVariables
  >({
    mutationFn: (variables: RejectBulkUpdateVariables) =>
      fetchRejectBulkUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApplyBulkUpdatePathParams = {
  bulkUpdateId: string;
};

export type ApplyBulkUpdateError = Fetcher.ErrorWrapper<undefined>;

export type ApplyBulkUpdateVariables = {
  body: Schemas.ApprovalRequest;
  pathParams: ApplyBulkUpdatePathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchApplyBulkUpdate = (
  variables: ApplyBulkUpdateVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    ApplyBulkUpdateError,
    Schemas.ApprovalRequest,
    {},
    {},
    ApplyBulkUpdatePathParams
  >({
    url: "/api/v3/clusters/bulk-update/{bulkUpdateId}/apply",
    method: "put",
    ...variables,
    signal,
  });

export const useApplyBulkUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      ApplyBulkUpdateError,
      ApplyBulkUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    ApplyBulkUpdateError,
    ApplyBulkUpdateVariables
  >({
    mutationFn: (variables: ApplyBulkUpdateVariables) =>
      fetchApplyBulkUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetApiariesError = Fetcher.ErrorWrapper<undefined>;

export type GetApiariesResponse = string[];

export type GetApiariesVariables = V3ApiContext["fetcherOptions"];

/**
 * Retrieve a list of all available apiary/deployment label IDs
 */
export const fetchGetApiaries = (
  variables: GetApiariesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<GetApiariesResponse, GetApiariesError, undefined, {}, {}, {}>({
    url: "/api/v3/apiaries",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Retrieve a list of all available apiary/deployment label IDs
 */
export const useGetApiaries = <TData = GetApiariesResponse,>(
  variables: GetApiariesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetApiariesResponse, GetApiariesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<GetApiariesResponse, GetApiariesError, TData>({
    queryKey: queryKeyFn({
      path: "/api/v3/apiaries",
      operationId: "getApiaries",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetApiaries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetSupportedExtensionsError = Fetcher.ErrorWrapper<undefined>;

export type GetSupportedExtensionsVariables = V3ApiContext["fetcherOptions"];

/**
 * List of available cluster extensions
 */
export const fetchGetSupportedExtensions = (
  variables: GetSupportedExtensionsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.SupportedExtensionsList,
    GetSupportedExtensionsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/api/v3/clusters/extensions",
    method: "get",
    ...variables,
    signal,
  });

/**
 * List of available cluster extensions
 */
export const useGetSupportedExtensions = <
  TData = Schemas.SupportedExtensionsList,
>(
  variables: GetSupportedExtensionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SupportedExtensionsList,
      GetSupportedExtensionsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    Schemas.SupportedExtensionsList,
    GetSupportedExtensionsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/clusters/extensions",
      operationId: "getSupportedExtensions",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetSupportedExtensions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ResyncHivePathParams = {
  orgId: string;
  clusterId: string;
};

export type ResyncHiveError = Fetcher.ErrorWrapper<undefined>;

export type ResyncHiveVariables = {
  pathParams: ResyncHivePathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchResyncHive = (
  variables: ResyncHiveVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    ResyncHiveError,
    undefined,
    {},
    {},
    ResyncHivePathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}/resync",
    method: "put",
    ...variables,
    signal,
  });

export const useResyncHive = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ResyncHiveError,
      ResyncHiveVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    undefined,
    ResyncHiveError,
    ResyncHiveVariables
  >({
    mutationFn: (variables: ResyncHiveVariables) =>
      fetchResyncHive({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateHiveCommentPathParams = {
  orgId: string;
  clusterId: string;
};

export type UpdateHiveCommentError = Fetcher.ErrorWrapper<undefined>;

export type UpdateHiveCommentVariables = {
  body: Schemas.HiveCommentUpdate;
  pathParams: UpdateHiveCommentPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchUpdateHiveComment = (
  variables: UpdateHiveCommentVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    UpdateHiveCommentError,
    Schemas.HiveCommentUpdate,
    {},
    {},
    UpdateHiveCommentPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}/comment",
    method: "put",
    ...variables,
    signal,
  });

export const useUpdateHiveComment = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateHiveCommentError,
      UpdateHiveCommentVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    undefined,
    UpdateHiveCommentError,
    UpdateHiveCommentVariables
  >({
    mutationFn: (variables: UpdateHiveCommentVariables) =>
      fetchUpdateHiveComment({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetClusterRevisionByIdPathParams = {
  orgId: string;
  clusterId: string;
  revisionId: string;
};

export type GetClusterRevisionByIdError = Fetcher.ErrorWrapper<undefined>;

export type GetClusterRevisionByIdVariables = {
  pathParams: GetClusterRevisionByIdPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetClusterRevisionById = (
  variables: GetClusterRevisionByIdVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ClusterRevision,
    GetClusterRevisionByIdError,
    undefined,
    {},
    {},
    GetClusterRevisionByIdPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions/{revisionId}",
    method: "get",
    ...variables,
    signal,
  });

export const useGetClusterRevisionById = <TData = Schemas.ClusterRevision,>(
  variables: GetClusterRevisionByIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ClusterRevision,
      GetClusterRevisionByIdError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    Schemas.ClusterRevision,
    GetClusterRevisionByIdError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions/{revisionId}",
      operationId: "getClusterRevisionById",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetClusterRevisionById({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetClusterAppliedRevisionPathParams = {
  orgId: string;
  clusterId: string;
};

export type GetClusterAppliedRevisionError = Fetcher.ErrorWrapper<undefined>;

export type GetClusterAppliedRevisionVariables = {
  pathParams: GetClusterAppliedRevisionPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetClusterAppliedRevision = (
  variables: GetClusterAppliedRevisionVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ClusterRevision,
    GetClusterAppliedRevisionError,
    undefined,
    {},
    {},
    GetClusterAppliedRevisionPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}/applied",
    method: "get",
    ...variables,
    signal,
  });

export const useGetClusterAppliedRevision = <TData = Schemas.ClusterRevision,>(
  variables: GetClusterAppliedRevisionVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ClusterRevision,
      GetClusterAppliedRevisionError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    Schemas.ClusterRevision,
    GetClusterAppliedRevisionError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/orgs/{orgId}/clusters/{clusterId}/applied",
      operationId: "getClusterAppliedRevision",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetClusterAppliedRevision(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type GetClusterRevisionsPathParams = {
  orgId: string;
  clusterId: string;
};

export type GetClusterRevisionsError = Fetcher.ErrorWrapper<undefined>;

export type GetClusterRevisionsResponse = Schemas.Revision[];

export type GetClusterRevisionsVariables = {
  pathParams: GetClusterRevisionsPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetClusterRevisions = (
  variables: GetClusterRevisionsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    GetClusterRevisionsResponse,
    GetClusterRevisionsError,
    undefined,
    {},
    {},
    GetClusterRevisionsPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions",
    method: "get",
    ...variables,
    signal,
  });

export const useGetClusterRevisions = <TData = GetClusterRevisionsResponse,>(
  variables: GetClusterRevisionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetClusterRevisionsResponse,
      GetClusterRevisionsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    GetClusterRevisionsResponse,
    GetClusterRevisionsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions",
      operationId: "getClusterRevisions",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetClusterRevisions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetClusterRevisionRenderPathParams = {
  orgId: string;
  clusterId: string;
  revisionId: string;
};

export type GetClusterRevisionRenderError = Fetcher.ErrorWrapper<undefined>;

export type GetClusterRevisionRenderVariables = {
  pathParams: GetClusterRevisionRenderPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetClusterRevisionRender = (
  variables: GetClusterRevisionRenderVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.Template,
    GetClusterRevisionRenderError,
    undefined,
    {},
    {},
    GetClusterRevisionRenderPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}/revision/{revisionId}/render",
    method: "get",
    ...variables,
    signal,
  });

export const useGetClusterRevisionRender = <TData = Schemas.Template,>(
  variables: GetClusterRevisionRenderVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.Template,
      GetClusterRevisionRenderError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    Schemas.Template,
    GetClusterRevisionRenderError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/orgs/{orgId}/clusters/{clusterId}/revision/{revisionId}/render",
      operationId: "getClusterRevisionRender",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetClusterRevisionRender(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApproveRevisionPathParams = {
  orgId: string;
  clusterId: string;
  revisionId: string;
};

export type ApproveRevisionError = Fetcher.ErrorWrapper<undefined>;

export type ApproveRevisionVariables = {
  body: Schemas.ApprovalRequest;
  pathParams: ApproveRevisionPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchApproveRevision = (
  variables: ApproveRevisionVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    ApproveRevisionError,
    Schemas.ApprovalRequest,
    {},
    {},
    ApproveRevisionPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions/{revisionId}/approve",
    method: "put",
    ...variables,
    signal,
  });

export const useApproveRevision = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      ApproveRevisionError,
      ApproveRevisionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    ApproveRevisionError,
    ApproveRevisionVariables
  >({
    mutationFn: (variables: ApproveRevisionVariables) =>
      fetchApproveRevision({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RejectRevisionPathParams = {
  orgId: string;
  clusterId: string;
  revisionId: string;
};

export type RejectRevisionError = Fetcher.ErrorWrapper<undefined>;

export type RejectRevisionVariables = {
  body: Schemas.ApprovalRequest;
  pathParams: RejectRevisionPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchRejectRevision = (
  variables: RejectRevisionVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    RejectRevisionError,
    Schemas.ApprovalRequest,
    {},
    {},
    RejectRevisionPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions/{revisionId}/reject",
    method: "put",
    ...variables,
    signal,
  });

export const useRejectRevision = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      RejectRevisionError,
      RejectRevisionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    RejectRevisionError,
    RejectRevisionVariables
  >({
    mutationFn: (variables: RejectRevisionVariables) =>
      fetchRejectRevision({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApplyRevisionPathParams = {
  orgId: string;
  clusterId: string;
  revisionId: string;
};

export type ApplyRevisionError = Fetcher.ErrorWrapper<undefined>;

export type ApplyRevisionVariables = {
  body: Schemas.ApprovalRequest;
  pathParams: ApplyRevisionPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchApplyRevision = (
  variables: ApplyRevisionVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    ApplyRevisionError,
    Schemas.ApprovalRequest,
    {},
    {},
    ApplyRevisionPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions/{revisionId}/apply",
    method: "put",
    ...variables,
    signal,
  });

export const useApplyRevision = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      ApplyRevisionError,
      ApplyRevisionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    ApplyRevisionError,
    ApplyRevisionVariables
  >({
    mutationFn: (variables: ApplyRevisionVariables) =>
      fetchApplyRevision({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RollbackRevisionPathParams = {
  orgId: string;
  clusterId: string;
  revisionId: string;
};

export type RollbackRevisionError = Fetcher.ErrorWrapper<undefined>;

export type RollbackRevisionVariables = {
  body: Schemas.ApprovalRequest;
  pathParams: RollbackRevisionPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchRollbackRevision = (
  variables: RollbackRevisionVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    RollbackRevisionError,
    Schemas.ApprovalRequest,
    {},
    {},
    RollbackRevisionPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions/{revisionId}/rollback",
    method: "put",
    ...variables,
    signal,
  });

export const useRollbackRevision = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      RollbackRevisionError,
      RollbackRevisionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    RollbackRevisionError,
    RollbackRevisionVariables
  >({
    mutationFn: (variables: RollbackRevisionVariables) =>
      fetchRollbackRevision({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetClusterSubscriptionPathParams = {
  orgId: string;
  clusterId: string;
};

export type GetClusterSubscriptionError = Fetcher.ErrorWrapper<undefined>;

export type GetClusterSubscriptionVariables = {
  pathParams: GetClusterSubscriptionPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetClusterSubscription = (
  variables: GetClusterSubscriptionVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ClusterSubscription,
    GetClusterSubscriptionError,
    undefined,
    {},
    {},
    GetClusterSubscriptionPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}/subscription",
    method: "get",
    ...variables,
    signal,
  });

export const useGetClusterSubscription = <TData = Schemas.ClusterSubscription,>(
  variables: GetClusterSubscriptionVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ClusterSubscription,
      GetClusterSubscriptionError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    Schemas.ClusterSubscription,
    GetClusterSubscriptionError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/orgs/{orgId}/clusters/{clusterId}/subscription",
      operationId: "getClusterSubscription",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetClusterSubscription({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetClusterSecretPathParams = {
  orgId: string;
  clusterId: string;
};

export type GetClusterSecretError = Fetcher.ErrorWrapper<undefined>;

export type GetClusterSecretResponse = {
  [key: string]: any;
};

export type GetClusterSecretVariables = {
  pathParams: GetClusterSecretPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetClusterSecret = (
  variables: GetClusterSecretVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    GetClusterSecretResponse,
    GetClusterSecretError,
    undefined,
    {},
    {},
    GetClusterSecretPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}/secrets",
    method: "get",
    ...variables,
    signal,
  });

export const useGetClusterSecret = <TData = GetClusterSecretResponse,>(
  variables: GetClusterSecretVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetClusterSecretResponse,
      GetClusterSecretError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    GetClusterSecretResponse,
    GetClusterSecretError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/orgs/{orgId}/clusters/{clusterId}/secrets",
      operationId: "getClusterSecret",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetClusterSecret({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PutClusterSecretPathParams = {
  orgId: string;
  clusterId: string;
};

export type PutClusterSecretError = Fetcher.ErrorWrapper<undefined>;

export type PutClusterSecretRequestBody = {
  [key: string]: any;
};

export type PutClusterSecretVariables = {
  body?: PutClusterSecretRequestBody;
  pathParams: PutClusterSecretPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchPutClusterSecret = (
  variables: PutClusterSecretVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    PutClusterSecretError,
    PutClusterSecretRequestBody,
    {},
    {},
    PutClusterSecretPathParams
  >({
    url: "/api/v3/orgs/{orgId}/clusters/{clusterId}/secrets",
    method: "put",
    ...variables,
    signal,
  });

export const usePutClusterSecret = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PutClusterSecretError,
      PutClusterSecretVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    undefined,
    PutClusterSecretError,
    PutClusterSecretVariables
  >({
    mutationFn: (variables: PutClusterSecretVariables) =>
      fetchPutClusterSecret({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAllClustersRevisionsQueryParams = {
  /**
   * The page number for pagination.
   *
   * @format int32
   * @default 1
   */
  page?: number;
  orgId?: string;
  /**
   * @example submitted
   */
  approvalState?: "submitted" | "rejected" | "approved" | "applied";
  /**
   * @example asc
   * @default desc
   */
  order?: "asc" | "desc";
  hiveId?: string;
  /**
   * Comma-separated list of organization-specific tags to filter clusters (OR logic)
   *
   * @example production,europe
   */
  tags?: string;
  templateId?: string;
  /**
   * Filter by hive state
   */
  hiveState?:
    | "RUNNING"
    | "PENDING"
    | "ERROR"
    | "DELETING"
    | "LOCKED"
    | "UNKNOWN";
  /**
   * Filter by apiary/deployment label ID
   *
   * @example apiary-a03-prod-eu-central-1
   */
  apiaryId?: string;
  /**
   * Flag to include hives which are disabled (therefore no proper state and marked to be removed)
   *
   * @default false
   */
  includeDisabled?: boolean;
  /**
   * Filter by cluster alias (case-insensitive partial match)
   *
   * @example prod
   */
  alias?: string;
};

export type GetAllClustersRevisionsError = Fetcher.ErrorWrapper<undefined>;

export type GetAllClustersRevisionsVariables = {
  queryParams?: GetAllClustersRevisionsQueryParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetAllClustersRevisions = (
  variables: GetAllClustersRevisionsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ClustersRevisionsResponse,
    GetAllClustersRevisionsError,
    undefined,
    {},
    GetAllClustersRevisionsQueryParams,
    {}
  >({ url: "/api/v3/clusters", method: "get", ...variables, signal });

export const useGetAllClustersRevisions = <
  TData = Schemas.ClustersRevisionsResponse,
>(
  variables: GetAllClustersRevisionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ClustersRevisionsResponse,
      GetAllClustersRevisionsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    Schemas.ClustersRevisionsResponse,
    GetAllClustersRevisionsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/clusters",
      operationId: "getAllClustersRevisions",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAllClustersRevisions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ImportHivePathParams = {
  /**
   * The deployment label identifier
   */
  deploymentLabel: string;
};

export type ImportHiveQueryParams = {
  /**
   * Associated subscription identifier
   */
  subscriptionId: string;
  /**
   * Associated subscription identifier
   */
  templateId: string;
};

export type ImportHiveError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: {
    /**
     * @example error
     */
    status?: string;
    /**
     * @example Invalid YAML format
     */
    message?: string;
  };
}>;

export type ImportHiveResponse = {
  /**
   * @example success
   */
  status?: string;
  /**
   * @example Configuration values applied successfully
   */
  message?: string;
  /**
   * @example config-12345
   */
  id?: string;
};

export type ImportHiveVariables = {
  pathParams: ImportHivePathParams;
  queryParams: ImportHiveQueryParams;
} & V3ApiContext["fetcherOptions"];

/**
 * Creates or updates cluster configuration using YAML-formatted values
 */
export const fetchImportHive = (
  variables: ImportHiveVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    ImportHiveResponse,
    ImportHiveError,
    undefined,
    {},
    ImportHiveQueryParams,
    ImportHivePathParams
  >({
    url: "/api/v3/apiaries/{deploymentLabel}/valuesobject",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Creates or updates cluster configuration using YAML-formatted values
 */
export const useImportHive = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ImportHiveResponse,
      ImportHiveError,
      ImportHiveVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    ImportHiveResponse,
    ImportHiveError,
    ImportHiveVariables
  >({
    mutationFn: (variables: ImportHiveVariables) =>
      fetchImportHive({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAuditLogsQueryParams = {
  /**
   * The page number for pagination.
   *
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * Start timestamp (epoch time in milliseconds) to filter audit logs.
   *
   * @format int64
   */
  from?: number;
  /**
   * End timestamp (epoch time in milliseconds) to filter audit logs.
   *
   * @format int64
   */
  to?: number;
  /**
   * Optional Hive ID to filter logs based on the `hiveId` field in request metadata.
   */
  hiveId?: string;
  /**
   * Optional Organization ID to filter logs based on the `orgId` field in request metadata.
   */
  orgId?: string;
  /**
   * Optional username to filter logs by the user who performed the action.
   */
  user?: string;
  /**
   * Optional User ID to filter logs based on the `userId` field in request metadata.
   */
  userId?: string;
  /**
   * Filter by action status (success or error).
   */
  status?: "success" | "error";
};

export type GetAuditLogsError = Fetcher.ErrorWrapper<undefined>;

export type GetAuditLogsVariables = {
  queryParams?: GetAuditLogsQueryParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetAuditLogs = (
  variables: GetAuditLogsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.AuditLogsResponse,
    GetAuditLogsError,
    undefined,
    {},
    GetAuditLogsQueryParams,
    {}
  >({ url: "/api/v3/audit/logs", method: "get", ...variables, signal });

export const useGetAuditLogs = <TData = Schemas.AuditLogsResponse,>(
  variables: GetAuditLogsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AuditLogsResponse,
      GetAuditLogsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    Schemas.AuditLogsResponse,
    GetAuditLogsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/audit/logs",
      operationId: "getAuditLogs",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAuditLogs({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetProductCatalogError = Fetcher.ErrorWrapper<undefined>;

export type GetProductCatalogVariables = V3ApiContext["fetcherOptions"];

export const fetchGetProductCatalog = (
  variables: GetProductCatalogVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<Schemas.Products, GetProductCatalogError, undefined, {}, {}, {}>({
    url: "/api/v3/product/catalog",
    method: "get",
    ...variables,
    signal,
  });

export const useGetProductCatalog = <TData = Schemas.Products,>(
  variables: GetProductCatalogVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Products, GetProductCatalogError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<Schemas.Products, GetProductCatalogError, TData>({
    queryKey: queryKeyFn({
      path: "/api/v3/product/catalog",
      operationId: "getProductCatalog",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetProductCatalog({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PostTemplateError = Fetcher.ErrorWrapper<undefined>;

export type PostTemplateVariables = {
  body: Schemas.NewTemplate;
} & V3ApiContext["fetcherOptions"];

export const fetchPostTemplate = (
  variables: PostTemplateVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.TemplateCreationResponse,
    PostTemplateError,
    Schemas.NewTemplate,
    {},
    {},
    {}
  >({
    url: "/api/v3/clusters/templates",
    method: "post",
    ...variables,
    signal,
  });

export const usePostTemplate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.TemplateCreationResponse,
      PostTemplateError,
      PostTemplateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.TemplateCreationResponse,
    PostTemplateError,
    PostTemplateVariables
  >({
    mutationFn: (variables: PostTemplateVariables) =>
      fetchPostTemplate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetTemplatesQueryParams = {
  /**
   * The page number for pagination.
   *
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @example asc
   * @default desc
   */
  order?: "asc" | "desc";
  /**
   * @example Starter,Dedicated
   */
  tags?: string;
  /**
   * Flag to include templates which are archived
   *
   * @default false
   */
  includeArchived?: boolean;
};

export type GetTemplatesError = Fetcher.ErrorWrapper<undefined>;

export type GetTemplatesVariables = {
  queryParams?: GetTemplatesQueryParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetTemplates = (
  variables: GetTemplatesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.TemplatesResponse,
    GetTemplatesError,
    undefined,
    {},
    GetTemplatesQueryParams,
    {}
  >({ url: "/api/v3/clusters/templates", method: "get", ...variables, signal });

export const useGetTemplates = <TData = Schemas.TemplatesResponse,>(
  variables: GetTemplatesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.TemplatesResponse,
      GetTemplatesError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<
    Schemas.TemplatesResponse,
    GetTemplatesError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/v3/clusters/templates",
      operationId: "getTemplates",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetTemplates({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetTemplateByIdPathParams = {
  templateId: string;
};

export type GetTemplateByIdError = Fetcher.ErrorWrapper<undefined>;

export type GetTemplateByIdVariables = {
  pathParams: GetTemplateByIdPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetTemplateById = (
  variables: GetTemplateByIdVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.Template,
    GetTemplateByIdError,
    undefined,
    {},
    {},
    GetTemplateByIdPathParams
  >({
    url: "/api/v3/clusters/templates/{templateId}",
    method: "get",
    ...variables,
    signal,
  });

export const useGetTemplateById = <TData = Schemas.Template,>(
  variables: GetTemplateByIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Template, GetTemplateByIdError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<Schemas.Template, GetTemplateByIdError, TData>({
    queryKey: queryKeyFn({
      path: "/api/v3/clusters/templates/{templateId}",
      operationId: "getTemplateById",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetTemplateById({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ArchiveTemplatePathParams = {
  templateId: string;
};

export type ArchiveTemplateError = Fetcher.ErrorWrapper<undefined>;

export type ArchiveTemplateRequestBody = {
  /**
   * Indicates whether the template should be archived or not.
   */
  archived?: boolean;
};

export type ArchiveTemplateVariables = {
  body?: ArchiveTemplateRequestBody;
  pathParams: ArchiveTemplatePathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchArchiveTemplate = (
  variables: ArchiveTemplateVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    ArchiveTemplateError,
    ArchiveTemplateRequestBody,
    {},
    {},
    ArchiveTemplatePathParams
  >({
    url: "/api/v3/clusters/templates/{templateId}/archive",
    method: "put",
    ...variables,
    signal,
  });

export const useArchiveTemplate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ArchiveTemplateError,
      ArchiveTemplateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    undefined,
    ArchiveTemplateError,
    ArchiveTemplateVariables
  >({
    mutationFn: (variables: ArchiveTemplateVariables) =>
      fetchArchiveTemplate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateTemplateTagsPathParams = {
  templateId: string;
};

export type UpdateTemplateTagsError = Fetcher.ErrorWrapper<undefined>;

export type UpdateTemplateTagsVariables = {
  body?: Schemas.Tags;
  pathParams: UpdateTemplateTagsPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchUpdateTemplateTags = (
  variables: UpdateTemplateTagsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    UpdateTemplateTagsError,
    Schemas.Tags,
    {},
    {},
    UpdateTemplateTagsPathParams
  >({
    url: "/api/v3/clusters/templates/{templateId}/tags",
    method: "put",
    ...variables,
    signal,
  });

export const useUpdateTemplateTags = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateTemplateTagsError,
      UpdateTemplateTagsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    undefined,
    UpdateTemplateTagsError,
    UpdateTemplateTagsVariables
  >({
    mutationFn: (variables: UpdateTemplateTagsVariables) =>
      fetchUpdateTemplateTags({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RemoveSecretReferencesError = Fetcher.ErrorWrapper<undefined>;

export type RemoveSecretReferencesResponse = {
  /**
   * A list of unique identifiers for the successfully processed hives.
   */
  hive_ids?: string[];
};

export type RemoveSecretReferencesRequestBody = {
  /**
   * A list of unique identifiers for the hives.
   */
  hive_ids: string[];
};

export type RemoveSecretReferencesVariables = {
  body: RemoveSecretReferencesRequestBody;
} & V3ApiContext["fetcherOptions"];

export const fetchRemoveSecretReferences = (
  variables: RemoveSecretReferencesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    RemoveSecretReferencesResponse,
    RemoveSecretReferencesError,
    RemoveSecretReferencesRequestBody,
    {},
    {},
    {}
  >({
    url: "/api/v3/clusters/removeSecretReferences",
    method: "put",
    ...variables,
    signal,
  });

export const useRemoveSecretReferences = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      RemoveSecretReferencesResponse,
      RemoveSecretReferencesError,
      RemoveSecretReferencesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    RemoveSecretReferencesResponse,
    RemoveSecretReferencesError,
    RemoveSecretReferencesVariables
  >({
    mutationFn: (variables: RemoveSecretReferencesVariables) =>
      fetchRemoveSecretReferences({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ForceDeleteSecretsError = Fetcher.ErrorWrapper<undefined>;

export type ForceDeleteSecretsResponse = {
  /**
   * A list of unique identifiers for the hives with successful deleted secrets.
   */
  hive_ids?: string[];
};

export type ForceDeleteSecretsRequestBody = {
  /**
   * A list of unique identifiers for the hives.
   */
  hive_ids: string[];
};

export type ForceDeleteSecretsVariables = {
  body: ForceDeleteSecretsRequestBody;
} & V3ApiContext["fetcherOptions"];

export const fetchForceDeleteSecrets = (
  variables: ForceDeleteSecretsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    ForceDeleteSecretsResponse,
    ForceDeleteSecretsError,
    ForceDeleteSecretsRequestBody,
    {},
    {},
    {}
  >({
    url: "/api/v3/clusters/forceDeleteSecrets",
    method: "put",
    ...variables,
    signal,
  });

export const useForceDeleteSecrets = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ForceDeleteSecretsResponse,
      ForceDeleteSecretsError,
      ForceDeleteSecretsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    ForceDeleteSecretsResponse,
    ForceDeleteSecretsError,
    ForceDeleteSecretsVariables
  >({
    mutationFn: (variables: ForceDeleteSecretsVariables) =>
      fetchForceDeleteSecrets({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetRolloutsQueryParams = {
  /**
   * The page number for pagination.
   *
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @example asc
   * @default desc
   */
  order?: "asc" | "desc";
  /**
   * @example Starter,Dedicated
   */
  tags?: string;
};

export type GetRolloutsError = Fetcher.ErrorWrapper<undefined>;

export type GetRolloutsVariables = {
  queryParams?: GetRolloutsQueryParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetRollouts = (
  variables: GetRolloutsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.Rollouts,
    GetRolloutsError,
    undefined,
    {},
    GetRolloutsQueryParams,
    {}
  >({ url: "/api/v3/rollouts", method: "get", ...variables, signal });

export const useGetRollouts = <TData = Schemas.Rollouts,>(
  variables: GetRolloutsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Rollouts, GetRolloutsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<Schemas.Rollouts, GetRolloutsError, TData>({
    queryKey: queryKeyFn({
      path: "/api/v3/rollouts",
      operationId: "getRollouts",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetRollouts({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type SubmitRolloutError = Fetcher.ErrorWrapper<undefined>;

export type SubmitRolloutVariables = {
  body: Schemas.RolloutSubmit;
} & V3ApiContext["fetcherOptions"];

export const fetchSubmitRollout = (
  variables: SubmitRolloutVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.RolloutResponse,
    SubmitRolloutError,
    Schemas.RolloutSubmit,
    {},
    {},
    {}
  >({ url: "/api/v3/rollouts", method: "post", ...variables, signal });

export const useSubmitRollout = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RolloutResponse,
      SubmitRolloutError,
      SubmitRolloutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.RolloutResponse,
    SubmitRolloutError,
    SubmitRolloutVariables
  >({
    mutationFn: (variables: SubmitRolloutVariables) =>
      fetchSubmitRollout({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApproveRolloutPathParams = {
  rolloutId: string;
};

export type ApproveRolloutError = Fetcher.ErrorWrapper<undefined>;

export type ApproveRolloutVariables = {
  body: Schemas.ApprovalRequest;
  pathParams: ApproveRolloutPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchApproveRollout = (
  variables: ApproveRolloutVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    ApproveRolloutError,
    Schemas.ApprovalRequest,
    {},
    {},
    ApproveRolloutPathParams
  >({
    url: "/api/v3/rollouts/{rolloutId}/approve",
    method: "put",
    ...variables,
    signal,
  });

export const useApproveRollout = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      ApproveRolloutError,
      ApproveRolloutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    ApproveRolloutError,
    ApproveRolloutVariables
  >({
    mutationFn: (variables: ApproveRolloutVariables) =>
      fetchApproveRollout({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RejectRolloutPathParams = {
  rolloutId: string;
};

export type RejectRolloutError = Fetcher.ErrorWrapper<undefined>;

export type RejectRolloutVariables = {
  body: Schemas.ApprovalRequest;
  pathParams: RejectRolloutPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchRejectRollout = (
  variables: RejectRolloutVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    RejectRolloutError,
    Schemas.ApprovalRequest,
    {},
    {},
    RejectRolloutPathParams
  >({
    url: "/api/v3/rollouts/{rolloutId}/reject",
    method: "put",
    ...variables,
    signal,
  });

export const useRejectRollout = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      RejectRolloutError,
      RejectRolloutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    RejectRolloutError,
    RejectRolloutVariables
  >({
    mutationFn: (variables: RejectRolloutVariables) =>
      fetchRejectRollout({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ExecuteRolloutPathParams = {
  rolloutId: string;
};

export type ExecuteRolloutError = Fetcher.ErrorWrapper<undefined>;

export type ExecuteRolloutVariables = {
  body: Schemas.ApprovalRequest;
  pathParams: ExecuteRolloutPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchExecuteRollout = (
  variables: ExecuteRolloutVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    ExecuteRolloutError,
    Schemas.ApprovalRequest,
    {},
    {},
    ExecuteRolloutPathParams
  >({
    url: "/api/v3/rollouts/{rolloutId}/apply",
    method: "put",
    ...variables,
    signal,
  });

export const useExecuteRollout = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      ExecuteRolloutError,
      ExecuteRolloutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    ExecuteRolloutError,
    ExecuteRolloutVariables
  >({
    mutationFn: (variables: ExecuteRolloutVariables) =>
      fetchExecuteRollout({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RollbackRolloutPathParams = {
  rolloutId: string;
};

export type RollbackRolloutError = Fetcher.ErrorWrapper<undefined>;

export type RollbackRolloutVariables = {
  body: Schemas.ApprovalRequest;
  pathParams: RollbackRolloutPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchRollbackRollout = (
  variables: RollbackRolloutVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    RollbackRolloutError,
    Schemas.ApprovalRequest,
    {},
    {},
    RollbackRolloutPathParams
  >({
    url: "/api/v3/rollouts/{rolloutId}/rollback",
    method: "put",
    ...variables,
    signal,
  });

export const useRollbackRollout = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      RollbackRolloutError,
      RollbackRolloutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useV3ApiContext();
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    RollbackRolloutError,
    RollbackRolloutVariables
  >({
    mutationFn: (variables: RollbackRolloutVariables) =>
      fetchRollbackRollout({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetTagsQueryParams = {
  /**
   * The page number for pagination.
   *
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @example asc
   * @default desc
   */
  order?: "asc" | "desc";
  /**
   * @example Starter,Dedicated
   */
  tags?: string;
};

export type GetTagsError = Fetcher.ErrorWrapper<undefined>;

export type GetTagsVariables = {
  queryParams?: GetTagsQueryParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetTags = (
  variables: GetTagsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.TagsResponse,
    GetTagsError,
    undefined,
    {},
    GetTagsQueryParams,
    {}
  >({ url: "/api/v3/tags", method: "get", ...variables, signal });

export const useGetTags = <TData = Schemas.TagsResponse,>(
  variables: GetTagsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.TagsResponse, GetTagsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<Schemas.TagsResponse, GetTagsError, TData>({
    queryKey: queryKeyFn({
      path: "/api/v3/tags",
      operationId: "getTags",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetTags({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetMeteringRecordsPathParams = {
  orgId: string;
  clusterId: string;
};

export type GetMeteringRecordsQueryParams = {
  /**
   * Start date of the time range in format dd/mm/yyyy
   *
   * @format date
   * @pattern ^\\d{2}/\\d{2}/\\d{4}$
   */
  from: string;
  /**
   * End date of the time range in format dd/mm/yyyy
   *
   * @format date
   * @pattern ^\\d{2}/\\d{2}/\\d{4}$
   */
  to: string;
};

export type GetMeteringRecordsHeaders = {
  Accept:
    | "application/json"
    | "text/csv"
    | "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
};

export type GetMeteringRecordsError = Fetcher.ErrorWrapper<undefined>;

export type GetMeteringRecordsVariables = {
  headers: GetMeteringRecordsHeaders;
  pathParams: GetMeteringRecordsPathParams;
  queryParams: GetMeteringRecordsQueryParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetMeteringRecords = (
  variables: GetMeteringRecordsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    string,
    GetMeteringRecordsError,
    undefined,
    GetMeteringRecordsHeaders,
    GetMeteringRecordsQueryParams,
    GetMeteringRecordsPathParams
  >({
    url: "/api/v3/orgs/{orgId}/metering/{clusterId}/records",
    method: "get",
    ...variables,
    signal,
  });

export const useGetMeteringRecords = <TData = string,>(
  variables: GetMeteringRecordsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<string, GetMeteringRecordsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<string, GetMeteringRecordsError, TData>({
    queryKey: queryKeyFn({
      path: "/api/v3/orgs/{orgId}/metering/{clusterId}/records",
      operationId: "getMeteringRecords",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetMeteringRecords({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetUserRolesPathParams = {
  /**
   * User ID or "me" for the current authenticated user
   */
  userId: string;
};

export type GetUserRolesError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: {
        /**
         * @example Invalid userId format.
         */
        message?: string;
      };
    }
  | {
      status: 401;
      payload: {
        /**
         * @example Authentication credentials were missing or incorrect.
         */
        message?: string;
      };
    }
  | {
      status: 403;
      payload: {
        /**
         * @example You do not have permission to access this resource.
         */
        message?: string;
      };
    }
>;

export type GetUserRolesVariables = {
  pathParams: GetUserRolesPathParams;
} & V3ApiContext["fetcherOptions"];

export const fetchGetUserRoles = (
  variables: GetUserRolesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.RoleList,
    GetUserRolesError,
    undefined,
    {},
    {},
    GetUserRolesPathParams
  >({
    url: "/api/v3/users/{userId}/roles",
    method: "get",
    ...variables,
    signal,
  });

export const useGetUserRoles = <TData = Schemas.RoleList,>(
  variables: GetUserRolesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.RoleList, GetUserRolesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options);
  return reactQuery.useQuery<Schemas.RoleList, GetUserRolesError, TData>({
    queryKey: queryKeyFn({
      path: "/api/v3/users/{userId}/roles",
      operationId: "getUserRoles",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetUserRoles({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type QueryOperation =
  | {
      path: "/api/v3/orgs/{orgId}/features";
      operationId: "getOrganisationFeatures";
      variables: GetOrganisationFeaturesVariables;
    }
  | {
      path: "/api/v3/orgs/{orgId}/users";
      operationId: "getOrgUsers";
      variables: GetOrgUsersVariables;
    }
  | {
      path: "/api/v3/orgs/{orgId}/support-users";
      operationId: "listSupportUsers";
      variables: ListSupportUsersVariables;
    }
  | {
      path: "/api/v3/orgs/{orgId}/tags";
      operationId: "getOrganizationClusterTags";
      variables: GetOrganizationClusterTagsVariables;
    }
  | {
      path: "/api/v3/orgs/{orgId}/idpConnections";
      operationId: "getOrganisationIdpConnections";
      variables: GetOrganisationIdpConnectionsVariables;
    }
  | {
      path: "/api/v3/orgs/{orgId}/clusters/{clusterId}";
      operationId: "getCluster";
      variables: GetClusterVariables;
    }
  | {
      path: "/api/v3/clusters/bulk-update/details";
      operationId: "getBulkClusterUpdatesDetails";
      variables: GetBulkClusterUpdatesDetailsVariables;
    }
  | {
      path: "/api/v3/clusters/bulk-update";
      operationId: "getBulkClusterUpdates";
      variables: GetBulkClusterUpdatesVariables;
    }
  | {
      path: "/api/v3/clusters/bulk-update/{bulkUpdateId}";
      operationId: "getBulkClusterUpdateDetails";
      variables: GetBulkClusterUpdateDetailsVariables;
    }
  | {
      path: "/api/v3/apiaries";
      operationId: "getApiaries";
      variables: GetApiariesVariables;
    }
  | {
      path: "/api/v3/clusters/extensions";
      operationId: "getSupportedExtensions";
      variables: GetSupportedExtensionsVariables;
    }
  | {
      path: "/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions/{revisionId}";
      operationId: "getClusterRevisionById";
      variables: GetClusterRevisionByIdVariables;
    }
  | {
      path: "/api/v3/orgs/{orgId}/clusters/{clusterId}/applied";
      operationId: "getClusterAppliedRevision";
      variables: GetClusterAppliedRevisionVariables;
    }
  | {
      path: "/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions";
      operationId: "getClusterRevisions";
      variables: GetClusterRevisionsVariables;
    }
  | {
      path: "/api/v3/orgs/{orgId}/clusters/{clusterId}/revision/{revisionId}/render";
      operationId: "getClusterRevisionRender";
      variables: GetClusterRevisionRenderVariables;
    }
  | {
      path: "/api/v3/orgs/{orgId}/clusters/{clusterId}/subscription";
      operationId: "getClusterSubscription";
      variables: GetClusterSubscriptionVariables;
    }
  | {
      path: "/api/v3/orgs/{orgId}/clusters/{clusterId}/secrets";
      operationId: "getClusterSecret";
      variables: GetClusterSecretVariables;
    }
  | {
      path: "/api/v3/clusters";
      operationId: "getAllClustersRevisions";
      variables: GetAllClustersRevisionsVariables;
    }
  | {
      path: "/api/v3/audit/logs";
      operationId: "getAuditLogs";
      variables: GetAuditLogsVariables;
    }
  | {
      path: "/api/v3/product/catalog";
      operationId: "getProductCatalog";
      variables: GetProductCatalogVariables;
    }
  | {
      path: "/api/v3/clusters/templates";
      operationId: "getTemplates";
      variables: GetTemplatesVariables;
    }
  | {
      path: "/api/v3/clusters/templates/{templateId}";
      operationId: "getTemplateById";
      variables: GetTemplateByIdVariables;
    }
  | {
      path: "/api/v3/rollouts";
      operationId: "getRollouts";
      variables: GetRolloutsVariables;
    }
  | {
      path: "/api/v3/tags";
      operationId: "getTags";
      variables: GetTagsVariables;
    }
  | {
      path: "/api/v3/orgs/{orgId}/metering/{clusterId}/records";
      operationId: "getMeteringRecords";
      variables: GetMeteringRecordsVariables;
    }
  | {
      path: "/api/v3/users/{userId}/roles";
      operationId: "getUserRoles";
      variables: GetUserRolesVariables;
    };
